<template>
  <v-container>
    <div class="not-found mt-15" :style="{color: fontColor}">
      <v-icon size="96" :color="fontColor">mdi-help-box</v-icon>
      {{ trans('general.pageNotFound') }}
    </div>
  </v-container>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'NotFoundPage',
  mixins: [
    LocaleUtils
  ],
  data () {
    return {
      fontColor: "#999999"
    }
  },
  computed: {
    pageTitle () {
      return this.trans('general.pageNotFound');
    }
  }
}
</script>

<style scoped lang="scss">
.not-found {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 300;

  i {
    margin-bottom: 0.3rem;
  }
}
</style>
